import React, { useCallback, useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd-v5';
import {
  DeleteOutlined,
  EditOutlined,
  FolderAddOutlined,
  InfoCircleOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import './styles.scss';
import SaveProductModal from '../../../../../componentsV2/Products/SaveProductModal';
import { isUrlImageValid } from '../../../../../utils/checkImage';

const ProductsV2DetailsHeader = props => {
  const {
    loading,
    product,
    showDetailsDrawer,
    setShowDetailsDrawer,
    showClientCollectionModal,
    setShowClientCollectionModal,
    showShareProductModal,
    setShowShareProductModal,
    showDeleteProductModal,
    setShowDeleteProductModal,
    fetchProduct,
    handleOnSuccessSave,
    isClientPage,
  } = props;

  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const [showShareButton, setShowShareButton] = useState(false);

  const enableShareButton = useCallback(async () => {
    if (product.images.length === 0) return false;
    const productsPrimaryImage = product.images.filter(image => image.isPrimary);
    if (productsPrimaryImage.length > 0) {
      return await isUrlImageValid(productsPrimaryImage[0].url);
    }
    return await isUrlImageValid(product.images[0].url);
  }, [product.images]);

  useEffect(() => {
    enableShareButton().then(result => {
      setShowShareButton(result);
    });
  }, [product.images]);

  const handleOnSuccess = useCallback(
    product => {
      handleOnSuccessSave(product);
      fetchProduct();
    },
    [handleOnSuccessSave],
  );

  return (
    <>
      <div className="products-v2-details-header">
        <div className="products-v2-details-header__title">{product.name}</div>

        <div className="products-v2-details-header__options">
          {!isClientPage && (
            <>
              {!product.posRefNum && !product.mpn ? (
                <Tooltip title="Edit Product">
                  <Button
                    size="large"
                    icon={<EditOutlined style={{ color: '#1677FF' }} />}
                    onClick={() => setShowEditProductModal(!showEditProductModal)}
                    disabled={loading}
                  />
                </Tooltip>
              ) : null}

              <Tooltip title="Add Product to Collection">
                <Button
                  size="large"
                  icon={<FolderAddOutlined style={{ color: '#1677FF' }} />}
                  onClick={() => setShowClientCollectionModal(!showClientCollectionModal)}
                  disabled={loading}
                />
              </Tooltip>
              <Tooltip title={showShareButton ? 'Share Product' : ' Needs Image to Send'}>
                <Button
                  size="large"
                  icon={<MessageOutlined style={{ color: '#1677FF' }} />}
                  onClick={() => setShowShareProductModal(!showShareProductModal)}
                  disabled={loading || !showShareButton}
                />
              </Tooltip>
            </>
          )}

          <Tooltip title="Show Product Details">
            <Button
              size="large"
              icon={<InfoCircleOutlined style={{ color: '#1677FF' }} />}
              onClick={() => setShowDetailsDrawer(!showDetailsDrawer)}
              disabled={loading}
            />
          </Tooltip>

          {!product.posRefNum && !product.mpn && !isClientPage ? (
            <Tooltip title="Delete Product">
              <Button
                size="large"
                icon={<DeleteOutlined style={{ color: '#f81d22' }} />}
                onClick={() => setShowDeleteProductModal(!showDeleteProductModal)}
                disabled={loading}
              />
            </Tooltip>
          ) : null}
        </div>
      </div>

      {!product.posRefNum && !product.mpn ? (
        <SaveProductModal
          productId={product.id}
          productData={product}
          open={showEditProductModal}
          setOpen={setShowEditProductModal}
          onSuccess={handleOnSuccess}
        />
      ) : null}
    </>
  );
};

export default ProductsV2DetailsHeader;
